import { IconWrapper } from '../runtime';
export default IconWrapper('rotate-left', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M14.25 13.9998V9.74976C14.25 6.43605 11.5637 3.74976 8.24999 3.74976C8.24999 3.74976 8.24999 3.74976 8.24999 3.74976C8.24999 3.74976 4.21177 3.74976 1.62426 3.74976M3.49999 1.74976L1.71213 3.53762L1.5 3.74976L1.71213 3.96189L3.49999 5.74976M5.24999 14.2498H7.74999C8.57842 14.2498 9.24999 13.5782 9.24999 12.7498V10.2498C9.24999 9.42133 8.57842 8.74976 7.74999 8.74976H5.24999C4.42157 8.74976 3.74999 9.42133 3.74999 10.2498V12.7498C3.74999 13.5782 4.42157 14.2498 5.24999 14.2498Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});